<template>
  <v-container fluid fill-height>
    <v-card flat height="auto" width="300px" style="margin: 0 auto 0 auto">
      <v-card flat>
        <div v-if="!getSuccess">
          <div class="pb-5" style="text-align:center;">
            <span
              >Please enter your email and your new password for your
              account.</span
            >
          </div>
          <v-form v-model="isFormValid">
            <v-row no-gutters justify="center">
              <v-text-field
                filled
                hide-details
                prepend-inner-icon="mdi-email"
                label="your@example.com"
                :rules="emailRules"
                v-model="email"
                style="margin: 10px; margin-top: 0 !important; padding: 0px;"
              />
            </v-row>
            <v-row no-gutters justify="center">
              <v-text-field
                filled
                hide-details
                label="New Password"
                :rules="nameRules"
                v-model="confirmPassword"
                :type="showConfirm ? 'text' : 'password'"
                @click:append="showConfirm = !showConfirm"
                :append-icon="showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                style="margin: 10px; margin-top: 0 !important; padding: 0px;"
              />
            </v-row>
            <v-row no-gutters justify="center">
              <v-text-field
                filled
                hide-details
                label="Confirm Password"
                :rules="passwordRules"
                v-model="newPassword"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                style="margin: 10px; margin-top: 0 !important; padding: 0px;"
              />
            </v-row>
          </v-form>
          <v-row class="d-flex justify-center">
            <h4 style="color: red;">{{ getError }}</h4>
          </v-row>
          <v-row no-gutters class="pt-5">
            <v-btn
              @click="submitPassword"
              large
              :disabled="!isFormValid"
              color="primary"
              style="width: 100%;"
              >Submit</v-btn
            >
          </v-row>
        </div>
        <div v-else style="text-align:center;">
          <span>Your password has been changed successfully.</span>
          <v-row no-gutters class="pt-5">
            <v-btn
              @click="goBack"
              large
              color="light-green"
              style="width: 100%;"
              >Done</v-btn
            >
          </v-row>
        </div>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
// eslint-disable-next-line no-unused-vars
import router from '../../router';

export default {
  data() {
    return {
      showPassword: false,
      showConfirm: false,
      email: '',
      code: '',
      newPassword: '',
      confirmPassword: '',
      isFormValid: false,
      nameRules: [
        (v) => !!v || 'A value must be entered.',
        (v) => v.length >= 1 || 'A value must be entered.',
      ],
      passwordRules: [
        (v) => !!v || 'Password is required',
        (v) => v === this.confirmPassword || 'Password must match',
      ],
      emailRules: [(v) => /.+@.+/.test(v) || 'Invalid Email address'],
    };
  },
  mounted() {
    this.code = router.currentRoute.query.code;
    this.setError(null);
  },
  methods: {
    ...mapActions({
      _changePassword: 'auth/changePassword',
    }),
    ...mapMutations({
      setError: 'auth/setError',
      setSuccess: 'auth/setSuccess',
    }),
    goBack() {
      this.setError(null);
      router.push('/login');
      this.setSuccess(false);
    },
    submitPassword() {
      this.setError(null);
      const payload = {
        email: this.email,
        code: this.code,
        password: this.newPassword,
      };
      this._changePassword(payload);
    },
  },
  computed: {
    ...mapGetters({
      getError: 'auth/getError',
      getSuccess: 'auth/getSuccess',
    }),
  },
};
</script>

<style></style>
